<main>
  @if (!newQuote) {
    <div class="grid-3 mt-[2rem] gap-[1rem]">
      <div class="row-between-center under__line mb-[1rem]">
        <h2>Items</h2>
        <div class="button__wrapper">
          <p-button variant="outlined" label="Add quote" (onClick)="newQuote = true" />
        </div>
      </div>
    </div>
    <div class="grid-12">
      <div class="span-12">
        <app-requisition-items-table (editQuotation)="onEditQuotation($event)" />
      </div>
    </div>
  }

  <p-dialog
    [header]="'QuotationDetails.HeaderModal' | translateWF: 'Create Quotation'"
    [modal]="true"
    [(visible)]="newQuote"
    [style]="{ width: '90vw' }"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    appendTo="body"
  >
    <app-requisition-quote-details [requisition]="requisition!" [quotation]="editingQuotation" (cancelled)="emitterEvent($event)" />
  </p-dialog>
</main>
